module.exports = __webpack_public_path__ + "static/18-d099142af094c887a7bc1e3e68fc18ce.jpg";